exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".page-content > .simple-footer {\n  color: #808080;\n  padding: 16px;\n  position: sticky;\n  top: 100%;\n}\n.page-content > .simple-footer > p {\n  margin-top: 4px;\n}\n.page-content > .simple-footer > p a {\n  margin-left: 0.5em;\n}\n", ""]);
